import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as employeeDetailsReducer from '../employee-detail.reducer';
import * as bankDetailsReducer from '../reducers/bank-details.reducer';

export const selectBankList = createSelector(employeeDetailsReducer.getBankListState, bankDetailsReducer.getBankList);
